module.exports = __webpack_public_path__ + "static/media/video_poker.eb656e05.svg";